/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transfer_EquipmentInputs */



/**
* | output |
* | --- |
* | "Move associated equipment" |
*
* @param {Transfer_EquipmentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const transfer_equipment = /** @type {((inputs?: Transfer_EquipmentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transfer_EquipmentInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Move associated equipment")
	return /** @type {LocalizedString} */ ("Déplacer les équipements associés")
});